var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
let CommentElement = class CommentElement extends Vue {
    constructor() {
        super(...arguments);
        this.comment = "";
    }
    commentChanged(e) { return e; }
    get elementKey() { return "comment"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    created() { this.comment = this.value; }
    onValueChanged(val, _oldVal) { this.comment = val; }
};
__decorate([
    Prop({ required: true })
], CommentElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], CommentElement.prototype, "value", void 0);
__decorate([
    Inject()
], CommentElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], CommentElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], CommentElement.prototype, "commentChanged", null);
__decorate([
    Watch("value")
], CommentElement.prototype, "onValueChanged", null);
CommentElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "CommentElement",
    })
], CommentElement);
export default CommentElement;
